import { resolveBoolean } from '@ardoq/modal';
import { DrawerContainer } from './DrawerContainer';
import { DrawerProviderProps } from './types';
import { cloneElement, useState } from 'react';
import { DrawerCloseButton } from './DrawerCloseButton';

export const DrawerProvider = ({
  stackPageIsInFocus,
  shouldCloseOnEscapeKey = false,
  shouldCloseOnBackdropClick = false,
  closeDrawer,
  renderDrawer,
  hasBackdrop,
  id,
  ariaLabel,
}: DrawerProviderProps) => {
  const [showDrawer, setShowDrawer] = useState(true);

  const handleCloserDrawer = () => {
    setShowDrawer(false);
    closeDrawer();
  };

  const providedDrawerComponent = renderDrawer({ handleCloserDrawer });
  const orientation = providedDrawerComponent.props.orientation || 'horizontal';

  const drawerComponent = cloneElement(providedDrawerComponent, {
    controls: providedDrawerComponent.props.controls ?? (
      <DrawerCloseButton onClose={handleCloserDrawer} />
    ),
  });

  return (
    <DrawerContainer
      orientation={orientation}
      onEscPress={async () =>
        stackPageIsInFocus &&
        (await resolveBoolean(shouldCloseOnEscapeKey)) &&
        handleCloserDrawer()
      }
      onBackdropClick={async () =>
        (await resolveBoolean(shouldCloseOnBackdropClick)) &&
        handleCloserDrawer()
      }
      isVisible={showDrawer}
      hasBackdrop={hasBackdrop}
      id={id}
      ariaLabel={ariaLabel}
    >
      {drawerComponent}
    </DrawerContainer>
  );
};
